<template>
    <div>
        <adminmenuSM v-if="screenWidth < 540" />
        <adminMenuMd v-else-if="screenWidth < 1058" />
        <adminMenuLg v-else />
    </div>
</template>

<script>
import adminmenuSM from "./admin/admin-menu-sm.vue";
import adminMenuMd from "./admin/admin-menu-md.vue";
import adminMenuLg from "./admin/admin-menu-lg.vue";

export default {
    name: 'AdminIndex',
    components: {
        adminmenuSM,
        adminMenuMd,
        adminMenuLg,
    },
    data() {
        return {
            screenWidth: window.innerWidth,
        };
    },
    methods: {
        updateScreenWidth() {
            this.screenWidth = window.innerWidth;
        },
    },
    mounted() {
        window.addEventListener("resize", this.updateScreenWidth);
    },
    beforeUnmount() {
        window.removeEventListener("resize", this.updateScreenWidth);
    },
};
</script>